import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 md:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-1 font-semibold" }
const _hoisted_8 = { class: "mb-1 font-semibold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mb-1 font-semibold" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mb-1 font-semibold" }
const _hoisted_13 = { class: "mb-1 flex items-center gap-2 font-semibold" }
const _hoisted_14 = { class: "mb-4 text-base font-semibold text-gray-800" }
const _hoisted_15 = { class: "relative grid grid-cols-2 gap-4 lg:grid-cols-4 xl:grid-cols-6" }
const _hoisted_16 = { class: "font-medium" }
const _hoisted_17 = {
  key: 0,
  class: "absolute -right-[215px] bottom-0 mt-6 flex flex-col justify-between rounded border-b-4 border-r-4 border-cyan-600 bg-gray-50 px-4 py-3 text-sm text-gray-600 shadow"
}
const _hoisted_18 = {
  key: 0,
  class: "relative mt-5 grid grid-cols-1 gap-4 md:grid-cols-6"
}
const _hoisted_19 = { class: "text-base font-semibold text-gray-800" }
const _hoisted_20 = { class: "text-base font-semibold text-gray-800" }

import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useUiStore } from '@/stores';
import { UserService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { UserModel, Permission, UserDeviceType, UserDeviceModel } from '@/types';

import { DesktopComputerIcon, DeviceMobileIcon } from '@heroicons/vue/solid';
import { InformationCircleIcon } from '@heroicons/vue/solid';
import SVGDeviceExternal from '@/components/svg/SVGDeviceExternal.vue';
import SVGChromeLogo from '@/components/svg/SVGChromeLogo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();
const { t } = useI18n();

const user = ref<UserModel | null>(null);
const isLoading = ref(false);

const setLoading = (loading: boolean) => {
    isLoading.value = loading;
    uiStore.setIsLoading(loading);
};

const fetchUsers = async (id: number) => {
    setLoading(true);
    try {
        const response = await UserService.get<UserModel>(id);
        user.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const deviceCards = [
    {
        type: UserDeviceType.MOBILE,
        icon: DeviceMobileIcon,
    },
    {
        type: UserDeviceType.DESKTOP,
        icon: DesktopComputerIcon,
    },
    {
        type: UserDeviceType.WEB,
        icon: SVGChromeLogo,
    },
    {
        type: UserDeviceType.EXTERNAL,
        icon: SVGDeviceExternal,
    },
];

const devicesByType = computed<Record<UserDeviceType, UserDeviceModel | undefined>>(() => {
    const map = {} as Record<UserDeviceType, UserDeviceModel | undefined>;
    for (const d of user.value?.devices ?? []) map[d.deviceType] = d;
    return map;
});

const hasDevice = (type: UserDeviceType) => Boolean(devicesByType.value[type]);
const externalDevice = computed(() => devicesByType.value[UserDeviceType.EXTERNAL]);

const autoAttendantTooltip = computed(() => {
    return `<span class='text-base'>${t('user.tooltips.useAutoAttendant')}</span>`;
});

onMounted(() => {
    fetchUsers(Number(route.params.id));
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('user.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListUser' } }),
          (_ctx.$can(_unref(Permission).EDIT_USER))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                            name: 'EditUserById',
                            params: {
                                id: _unref(route).params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('user.labels.name')), 1),
              _createElementVNode("p", null, _toDisplayString(user.value?.name), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('user.labels.email')), 1),
              _createElementVNode("p", null, _toDisplayString(user.value?.email), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('user.labels.roles')), 1),
              _createElementVNode("p", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value?.roles, (role, index) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_ROLE) ? 'RouterLink' : 'span'), {
                    key: `role-${role.id}`,
                    to: 
                                    _ctx.$can(_unref(Permission).VIEW_ROLE)
                                        ? { name: 'ViewRoleById', params: { id: role.id } }
                                        : undefined
                                ,
                    class: _normalizeClass([
                                    _ctx.$can(_unref(Permission).VIEW_ROLE) && 'text-primary',
                                    index !== (user.value?.roles?.length || 0) - 1 ? 'mr-0.5' : '',
                                ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(role.name), 1),
                      (index !== (user.value?.roles?.length || 0) - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, ","))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('user.labels.levels')), 1),
              _createElementVNode("p", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value?.levels, (level, index) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_LEVEL) ? 'RouterLink' : 'span'), {
                    key: `level-${level.id}`,
                    to: 
                                    _ctx.$can(_unref(Permission).VIEW_LEVEL)
                                        ? { name: 'ViewLevelById', params: { id: level.id } }
                                        : undefined
                                ,
                    class: _normalizeClass([
                                    _ctx.$can(_unref(Permission).VIEW_LEVEL) && 'text-primary',
                                    index !== (user.value?.levels?.length || 0) - 1 ? 'mr-0.5' : '',
                                ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(level.name), 1),
                      (index !== (user.value?.levels?.length || 0) - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, ","))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('user.labels.standardLevel')), 1),
              _createElementVNode("p", null, _toDisplayString(user.value?.standardLevel?.name), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t('user.labels.useAutoAttendant')) + " ", 1),
                _withDirectives(_createVNode(_unref(InformationCircleIcon), {
                  class: "h-4 w-4 text-gray-400",
                  "aria-hidden": "true"
                }, null, 512), [
                  [_directive_tippy, { content: autoAttendantTooltip.value, allowHTML: true }]
                ])
              ]),
              _createElementVNode("p", null, _toDisplayString(user.value?.useAutoAttendant
                                    ? _ctx.$t('user.filters.isActive.options.active')
                                    : _ctx.$t('user.filters.isActive.options.inactive')), 1)
            ])
          ]),
          _createVNode(_component_UiAuditStatusInfo, {
            "model-value": user.value,
            class: "bt-1 mt-4 border-t border-gray-300 pt-2"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('user.labels.devices.title')), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceCards, (d) => {
              return _createElementVNode("div", {
                key: d.type,
                class: _normalizeClass([
                            hasDevice(d.type)
                                ? 'bg-cyan-50 text-cyan-600'
                                : 'bg-gray-50 text-gray-400',
                            'relative flex h-40 w-40 flex-col items-center rounded shadow ring-1 ring-gray-300 focus:ring-2 focus:ring-opacity-50',
                        ])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(d.icon), { class: "mt-6 h-20 w-20" })),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('user.labels.devices.' + d.type)), 1),
                (d.type === _unref(UserDeviceType).EXTERNAL && externalDevice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-1 text-base font-semibold" }, "Configurações do PABX", -1)),
                      _createElementVNode("p", null, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-semibold" }, "Hostname:", -1)),
                        _createTextVNode(" " + _toDisplayString(externalDevice.value.hostname), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-semibold" }, "Username:", -1)),
                        _createTextVNode(" " + _toDisplayString(externalDevice.value.sipUser), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold" }, "Password:", -1)),
                        _createTextVNode(" " + _toDisplayString(externalDevice.value.sipPassword), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            }), 64))
          ]),
          (user.value?.devices?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('user.labels.extension.number')), 1),
                  _createElementVNode("p", null, _toDisplayString(user.value?.extension?.number), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('user.labels.number')), 1),
                  _createElementVNode("pre", null, _toDisplayString(user.value?.numbers?.map((n) => n.number).join(', ') || _ctx.$t('core.random')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})